import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './common/header/header';
import { FooterComponent } from './common/footer/footer';
import { ToastModule } from 'primeng/toast';

@Component({
  selector: 'app-root',
  standalone: true,                          
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    ToastModule
  ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
    //TODO: need to route user to login page when the app received 401 from any of the service.
}
